import Cookies from 'js-cookie';
import create from '@verndale/core';
import modules from '../modules';

const _window = window;

export const PERSONALIZE_COMPONENT_LOADED_EVENT = 'personalizeComponentLoaded';

export const dispatchPersonaViewEvent = () => {
  const _window = window;

  //get page url
  const url = window.location.href;

  let zip = '';

  const akGeoString = Cookies.get('ak_geo');
  const akGeo = akGeoString ? JSON.parse(akGeoString) : {};

  if (akGeo?.postal) {
    zip = akGeo.postal.split('-')[0];
  }

  const event = {
    channel: 'WEB',
    currency: 'USD',
    page: url
  };
  const extensionData = {
    state: akGeo?.region || '',
    city: akGeo?.city || '',
    zipCode: zip || '',
    dmaRegionCode: akGeo?.dma || '',
    metroCode: akGeo?.msa || '',
    pmsaCode: akGeo?.pmsa || '',
    country: akGeo?.country || '',
    fips: akGeo?.fips || ''
  };
  // Send VIEW event
  if (_window.engage) {
    _window.engage.pageView(event, extensionData);
  }
};

export const handlePersonalizeComponentLoaded = e => {
  const elementId = e.detail.id;
  const element = document.getElementById(elementId);

  if (element) {
    const elementDataModule = element.dataset.module;
    const childrenWithModule = element.querySelectorAll('[data-module]') || [];

    const modulesName = [elementDataModule];

    childrenWithModule.forEach(child => {
      const dataModule = child.dataset.module;

      if (dataModule) {
        modulesName.push();
      }
    });

    const modulesToLoad = modules.filter(module =>
      modulesName.includes(module.name)
    );

    create(modulesToLoad);
  }
};

const initPersonalize = () => {
  const settings = _window.personalizeSettings;
  if (settings) {
    _window.Engage.init(settings).then(e => {
      _window.engage = e;
      dispatchPersonaViewEvent();
    });
  } else {
    console.error('Personalize settings not found');
  }
};

export const initPersonalizeActions = () => {
  if (_window.Engage) {
    initPersonalize();
  } else {
    let attempts = 0;
    const retryInterval = setInterval(() => {
      attempts++;
      if (attempts === 100) {
        clearInterval(retryInterval);
      }
      if (_window.Engage) {
        initPersonalize();
        clearInterval(retryInterval);
      }
    }, 100);
  }
};
